import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";
import ImageModal from "../../../../src/modules/Dashboard/DashboardComponent/ImageModalComponent/ImageModalComponent";

const ForthComing = () => {
  const [forthComing, setForthComing] = useState([]);
  const [empAnniversary, setEmpAnniversary] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [user, setUser] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Forthcoming"));
    fetchForthComingDetails();
  }, [dispatch]);

  const handleImageClick = useCallback((imageUrl) => {
    setModalImage(imageUrl);
  }, []);

  const closeModal = useCallback(() => {
    setModalImage(null);
  }, []);

  const parseCustomDate = (dateStr) => {
    return moment(dateStr, "dddd, MMM DD");
  };

  const fetchForthComingDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}org/forthcoming`);
      const { data } = response?.data || {};

      const sortByNearestDate = (arr) => {
        return [...arr].sort((a, b) => {
          const dateA = parseCustomDate(a.Date);
          const dateB = parseCustomDate(b.Date);
          return dateA - dateB;
        });
      };

      setForthComing(sortByNearestDate(data?.upcomingBirthday || []));
      setEmpAnniversary(sortByNearestDate(data?.upcomingWorkAnniversary || []));
      setHoliday(sortByNearestDate(data?.upcomingHoliday || []));
      setUser(sortByNearestDate(data?.upcomingForthComing || []));
    } catch (error) {
      console.error("Error fetching ForthComing Details:", error);
    } finally {
      setPageLoading(false);
    }
  };

  const CardSection = ({ title, data, isHoliday = false }) => (
    <div className="forth-card shadow-sm h-100">
      <div className="forth-card-header">
        <h6>
          <strong>{title}</strong>
        </h6>
      </div>
      <div className="card-body px-2 forthcoming-card-body">
        {data.length > 0 ? (
          data.map((joinee) => (
            <PersonCard key={joinee.ID} joinee={joinee} isHoliday={isHoliday} />
          ))
        ) : (
          <NoRecordsFound />
        )}
      </div>
    </div>
  );

  const PersonCard = ({ joinee, isHoliday }) => {
    return (
      <div className="forth-person-card mb-2">
        <div className="d-flex align-items-center p-1">
          <div className="forth-img-joinee">
            {isHoliday ? (
              <div className="forth-img-div">
                <img
                  src={joinee.ImagePath || ""}
                  alt={joinee.title}
                  className="forth-img"
                  onClick={ !isHoliday ? () => handleImageClick(joinee.ImagePath) : undefined }
                  style={{ cursor: !isHoliday ? "pointer" : "default" }}
                />
              </div>
            ) : (
              <img
                src={joinee.ImagePath || ""}
                alt={joinee.title}
                className="forth-img-joinee"
                onClick={() => handleImageClick(joinee.ImagePath)}
                style={{ cursor: "pointer" }}
              />
            )}
          </div>
          <div className="flex-grow-1">
            <h6 className="forth-person-name">{joinee.title}</h6>
            <p className="forth-person-position">{joinee.Message}</p>
          </div>
          <div className="forth-date">
            <span className="forth-date-icon me-1">
              <i className="bi bi-calendar-week"></i>
            </span>
            {joinee.Date}
          </div>
        </div>
      </div>
    );
  };

  const NoRecordsFound = () => (
    <div className="d-flex justify-content-center align-items-center h-100">
      No Record Found
    </div>
  );

  const LoadingSpinner = () => (
    <p className="position-absolute top-50 start-50 translate-middle text-center">
      <FaSpinner className="spinner" />
    </p>
  );

  if (pageLoading) return <LoadingSpinner />;

  return (
    <div className="container-fluid mt-2">
      <div className="row g-2">
        <div className="col-lg-6 dashKPI">
          <CardSection title="Upcoming Birthdays" data={forthComing} />
        </div>

        <div className="col-lg-6 dashKPI">
          <CardSection
            title="Upcoming Holidays"
            data={holiday}
            isHoliday={true}
          />
        </div>

        <div className="col-lg-6 dashKPI">
          <CardSection
            title="Upcoming Work Anniversaries"
            data={empAnniversary}
          />
        </div>

        <div className="col-lg-6 dashKPI">
          <CardSection title="Fun @ Nice" data={user} />
        </div>
      </div>
      <ImageModal
        isOpen={!!modalImage}
        imageUrl={modalImage}
        onClose={closeModal}
      />
    </div>
  );
};

export default ForthComing;
